import PropTypes from 'prop-types';
import React from 'react';

import Formaters from '../../formatters';

function Date({ value }) {
    if (value) {
        return (
            <span className="format-full-date" data-value={value}>
                {Formaters.date(value)}
            </span>
        );
    }
    return null;
}

Date.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Date;
